<template>
    <v-row :class="'align-center '+options.class">
      <v-col cols="12" :class="{'py-0 text-center':true, 'text--disabled': !value}">
        {{ title }}
      </v-col>
      <v-col cols="12" class="py-0">
        <v-progress-linear
            :color="barColor"
            :stream="stream"
            rounded
            :value="itemValue"
            :buffer-value="stream ? 0 : 100"
            :height="options.size"
        >
          <template v-slot:default="{ value }" v-if="value">
            <strong v-if="options.bold">{{ Math.round(value*10)/10 }}%</strong>
            <span class="caption" v-else>{{ Math.round(value) }}%</span>
          </template>
        </v-progress-linear>
      </v-col>
    </v-row>
</template>

<script>
  export default {
    name: "ItemBalance",
    props: ['title', 'value','type','stream'], //type=1 optional, type=2 small
    data() {
      return {
      }
    },
    computed: {
      colors() {
        return this.$store.getters['app/colors']
      },
      options() {
        let size = 20
        let bold = true
        let styleClass = 'mt-1'
        if (this.type === 2) {
          size = 12
          bold = false
          styleClass = 'mt-2'
        }
        return {size: size, bold: bold, class:styleClass}
      },
      barColor() {
        let color = 'grey'
        if (this.value >= 70) {
          color = this.stream ? this.colors.green : this.colors.lgreen
        } else if (this.value >= 50) {
          color = this.stream ? this.colors.yellowd : this.colors.yellow
        } else if ( this.value && this.value < 50) {
          color = this.stream ? this.colors.red : this.colors.lred
        }
        return color
      },
      itemValue() {
        if (this.value) {
          return this.value
        } else {
          return 0
        }
      }
    }
  }

</script>